<script context="module" lang="ts">
  export const CanvasContextKEY = Symbol();

  export type WebGLRenderingContextState = {
    gl: Writable<WebGLRenderingContext | null>;
  };

  function newWebGLRenderingContextStore() {
    return writable<WebGLRenderingContext | null>(null);
  }
</script>

<script lang="ts">
  import { browser } from '$app/environment';
  import { instrumentGLContext } from '@luma.gl/gltools';
  import { onMount, setContext } from 'svelte';
  import { writable, type Writable } from 'svelte/store';

  let contextStore = newWebGLRenderingContextStore();
  let canvas: HTMLCanvasElement;

  setContext(CanvasContextKEY, { gl: contextStore });

  onMount(() => {
    if (!browser) return;
    contextStore.set(instrumentGLContext(canvas.getContext('webgl')!));
  });
</script>

<slot />
<div class="shared-canvas">
  <canvas bind:this={canvas} />
</div>

<style lang="scss">
  @import 'src/scss/variables';

  .shared-canvas {
    position: relative;
    width: 100%;
    height: 100%;
    max-width: 2800px;
    margin: var(--twist-core-spacing-0) auto;
    z-index: -999;
    pointer-events: none;
  }
  canvas {
    position: fixed !important;
    max-width: 2800px;
    margin: var(--twist-core-spacing-0) auto;
    z-index: map-get($zIndex, page-background);
    width: 100vw;
    height: var(--vh);
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    backface-visibility: hidden;
  }
</style>
